import { PayloadAction, ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { ITasksState } from '.';
import { api } from '../../api/api';

export interface ICheckVkShareResponse {
    taskId: number;
    pendingTime: number;
};

export const checkVkShareTask = createAsyncThunk<ICheckVkShareResponse, number>(
    'checkVkShareTask',
    async (taskId: number) => await api.tasks.checkVkShareTask(taskId)
);

const checkVkShareTaskHandler = (builder: ActionReducerMapBuilder<ITasksState>) => {
    builder
        .addCase(checkVkShareTask.pending, (state: ITasksState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(checkVkShareTask.fulfilled, (state: ITasksState, action: PayloadAction<ICheckVkShareResponse>) => {
            state.loading = false;

            if (!action.payload) {
                state.error = 'Unable to check vk share task';
                return;
            }

            state.vkShareTasks.forEach(task => {
                if (task.taskId === action.payload.taskId)
                    task.pendingTime = action.payload.pendingTime;
            });
        })
        .addCase(checkVkShareTask.rejected, (state: ITasksState) => {
            state.loading = false;
            state.error = 'Unable to check vk share task';
        });
};

export default checkVkShareTaskHandler;